import React, { useEffect } from 'react';
import {
  useStripe,
  useElements,
  PaymentElement
} from "@stripe/react-stripe-js";
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { showErrorMessage } from 'redux/slices/notification';
import { setStripeTotalCharge } from 'redux/slices/cart';

export const StripeCardForm = ({ clientSecret, onSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const checkClientSecret = async () => {
      if (clientSecret) {
        const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);

        let error = '';

        if (paymentIntent) {
          dispatch(setStripeTotalCharge(paymentIntent.amount));
        }

        switch (paymentIntent?.status) {
          case "succeeded":
          case "requires_capture":
            onSuccess(paymentIntent);
            return;
          case "processing":
            error = 'Your payment is processing.';
            break;
          case "requires_payment_method":
            error = 'Your payment was not successful, please try again.';
            break;
          default:
            error = 'Something went wrong.';
            dispatch(showErrorMessage(error));
            break;
        }
      }
    }

    checkClientSecret();
  }, [clientSecret, onSuccess, stripe, dispatch]);

  const handleSubmit = async event => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    const currentUrl = new URL(window.location.href);

    currentUrl.searchParams.delete('payment_intent_client_secret');
    currentUrl.searchParams.delete('redirect_status');
    currentUrl.searchParams.delete('payment_intent');

    const response = await stripe.confirmPayment({
      elements,
      confirmParams: { return_url: currentUrl.toString() },
    });

    if (response.error.message) {
      dispatch(showErrorMessage(response.error.message));
    }
  };

  return (
    <form onSubmit={handleSubmit} className='mt-3' >
      <PaymentElement />
      <button
        type="submit"
        className='btn btn-blue mt-5 max-w-5xl p-4'
        disabled={!stripe}
      >
        Pay
      </button>
    </form>
  )
}

StripeCardForm.propTypes = {
  clientSecret: PropTypes.string,
  onSuccess: PropTypes.func
};
